export const sections = [
    {
      id: 'situation',
      questions: [
        {
          id: 'q01_age',
          text: '1. Quel est votre niveau de connaissance et de compréhension des marchés financiers ?',
          options: [
            { score: 1, label: 'Aucune connaissance' },
            { score: 2, label: 'Connaissance basique' },
            { score: 2, label: 'Connaissance intermédiaire' },
            { score: 3, label: 'Connaissance avancée' },
          ],
        },
        {
          id: 'q02_horizon',
          text: '2. Pensez-vous être conscients des conséquences des opérations financières envisagées sur votre portefeuille ?',
          options: [
            { score: 1, label: 'Non, je ne suis pas conscients', horizonBand: '1_3y' },
            { score: 2, label: 'Oui, je suis partiellement conscients', horizonBand: '3_7y' },
            { score: 3, label: 'Oui, je suis totalement conscients', horizonBand: '7_20y' },
          ],
        },
        {
          id: 'q03_echeance',
          text: '3. Concernant les placements financiers, en connaissez vous les différents produits ?',
          options: [
            { score: 1, label: 'Uniquement les placements bancaires traditionnels ' },
            { score: 2, label: 'Plusieurs principaux placements et leurs fluctuations  ' },
            { score: 3, label: 'Quelques principaux placements ' },
            { score: 4, label: 'Tous les placements, y compris les placements spéculatifs' },
          ],
        },
        {
          id: 'q04_part_epargne',
          text: '4. Quel est votre niveau d\'expertise concernant les produits financiers ?',
          options: [
            { score: 1, label: 'Néophyte ' },
            { score: 2, label: 'Moyennement expérimenté ' },
            { score: 3, label: 'Expérimenté ' },
          ],
        },
        {
            id: 'q05_connaissance',
            text: '5. Quelle est votre expérience des placements financiers en général ?',
            options: [
              { score: 1, label: 'Aucune expérience préalable' },
              { score: 2, label: 'Opérations réalisées et suivies seul (gestion directe)' },
              { score: 3, label: 'Opérations réalisées avec un conseiller (gestion conseillée)' },
              { score: 4, label: 'Mandat de gestion confié à un professionnel ' },
            ],
          },
          {
            id: 'q06_experience',
            text: '6. Selon quelle fréquence suivez-vous vos placements actuels ?',
            options: [
              { score: 1, label: 'Hebdomadaire' },
              { score: 2, label: 'Mensuelle' },
              { score: 3, label: 'Trimestrielle' },
              { score: 4, label: 'Annuelle' },
            ],
          },
          {
            id: 'q07_relation_risque',
            text: '7. Quelle est votre connaissance des instruments financiers ci-dessous et quels sont ceux sur lesquels vous avez déjà réalisé des transactions ?',
            type: 'matrix',
            /** Score de la question = somme des 10 sous-réponses (5 supports x 2 sous-questions). */
            instruments: [
              { id: 1, text: 'OPCVM monétaires et produits à capital garanti' },
              { id: 2, text: 'Actions et OPCVM actions' },
              { id: 3, text: 'Titres non cotés (FCPI et FCPR)' },
              { id: 4, text: 'Produits structurés' },
              { id: 5, text: 'Options, produits à terme, warrants, etc.' },
            ],
            subQuestions: [
              {
                id: 'connaissance',
                label: 'Niveau de connaissance',
                options: [
                  { score: 1, label: 'Faible' },
                  { score: 2, label: 'Moyen' },
                  { score: 3, label: 'Bonne' },
                ],
              },
              {
                id: 'investi',
                label: 'Avez-vous déjà investi dans ces supports',
                options: [
                  { score: 0, label: 'Non' },
                  { score: 1, label: 'Oui' },
                ],
              },
            ],
          },
          {
            id: 'q08_formation',
            text: '8. Avez-vous déjà investi dans les actions ou dans les supports investis en actions (FCP Actions, prise de participation dans les sociétés non cotéés ) ?',
            options: [
              { score: 3, label: 'Oui, j’étais satisfait' },
              { score: 2, label: 'Oui, je n’étais pas satisfait mais je suis prêt à investir à nouveau ' },
              { score: 1, label: 'Oui et je ne souhaite plus investir dans ce type d’actifs' },
              { score: 3, label: 'Non, mais c’est ce que j’envisage désormais' },
              { score: 1, label: 'Non et je ne l\'envisage pas'},
            ],
          },
          {
            id: 'q09_revenus',
            text: '9. Avez-vous déjà subi une baisse de valeur de vos placements financiers sur une année ? ',
            options: [
              { score: 1, label: 'Non' },
              { score: 1, label: 'Baisse inférieure à 10 % ' },
              { score: 2, label: 'Baisse comprise entre 10 % et 20 % ' },
              { score: 3, label: 'Baisse comprise entre 20 % et 30 % ' },
              { score: 4, label: 'Baisse supérieure à 30 % '}
            ],
          },
          {
            id: 'q10_reserve',
            text: '10. La valeur de votre investissement baisse de 20 %, comment réagissez-vous ? ',
            options: [
              { score: 1, label: 'Je désinvestis' },
              { score: 3, label: 'Je patiente' },
              { score: 4, label: 'Je réinvestis' },
            ],
          },
          {
            id: 'q11_capacite_perte',
            text: '11. La valeur de votre investissement augmente de 20 %, comment réagissez-vous ? ',
            options: [
              { score: 1, label: 'Je maintiens mon investissement en l’état' },
              { score: 2, label: 'Je réinvestis un montant inférieur ou égal à l’investissement initial' },
              { score: 3, label: 'Je réinvestis un montant supérieur à l’investissement initial' },
            ],
          },
          {
            id: 'q12_dettes',
            text: '12. Quels sont les objectifs de votre placement ? ',
            options: [
              { score: 3, label: 'Valoriser le capital ' },
              { score: 2, label: 'Revenus complémentaires à court terme' },
              { score: 2, label: 'Revenus complémentaires à moyen terme' },
              { score: 2, label: 'Revenus complémentaires à long terme ou préparation à la retraite ' },
              { score: 1, label: 'Constitution d’une épargne de précaution'},
              { score: 1, label: 'Transmission d’un capital en cas de décès '},
            ],
          },
          {
            id: 'q13_baisse_marche',
            text: '13. Quel pourcentage de votre patrimoine total représente le montant que vous envisagez d’investir ? ',
            options: [
              { score: 1, label: 'Moins de 25 %' },
              { score: 2, label: 'Entre 25 % et 50 %' },
              { score: 3, label: 'Entre 50 % et 75 % ' },
              { score: 4, label: 'Plus de 75 %' },
            ],
          },
          {
            id: 'q14_preference',
            text: '14. Le critère de liquidité est-il important dans le cadre de ce placement ? ',
            options: [
              { score: 1, label: 'Argent disponible à tout moment ' },
              { score: 2, label: 'Autres économies disponibles rapidement' },
            ],
          },
          {
            id: 'q15_volatilite',
            text: '15. Quelle est la durée envisagée de votre placement ? ',
            options: [
              { score: 1, label: 'Moins de 2 ans' },
              { score: 2, label: 'Entre 2 et 5 ans' },
              { score: 3, label: 'Entre 5 et 8 ans' },
              { score: 4, label: 'Plus de 8 ans' },
            ],
          },
          {
            id: 'q16_objectif',
            text: '16. Quelle performance attendez-vous de ce placement ? ',
            options: [
              { score: 1, label: 'Rendement très faible, sans risque de perte' },
              { score: 2, label: 'Rendement faible, avec peu de risques' },
              { score: 3, label: 'Rendement moyen, avec des risques de perte' },
              { score: 3, label: 'Rendement élevé, avec des risques élevés' },
              { score: 4, label: 'Rendement très élevé, avec des risques très élevés' },
            ],
          },
          {
            id: 'q17_arbitrage',
            text: '17. Entre deux portefeuilles sur 10 ans, l’un stable à rendement plus faible, l’autre fluctuant à rendement plus élevé, vous choisiriez :',
            options: [
              { score: 1, label: 'Aucune perte acceptée' },
              { score: 1, label: 'Variation de ±5 % ' },
              { score: 2, label: 'Variation de ±10 % ' },
              { score: 3, label: 'Variation de ±20 % ' },
              { score: 3, label: 'Variation de ±35 % ' },
              { score: 4, label: 'Variation supérieure à ±50 % ' },
            ],
          },
      ],
    },
  ];


/**
 * Seuils de classement (score total sur 17 questions).
 * `riskPreference` (security/balanced/performance) reste utilisé pour alimenter
 * risk.risk_preference dans wealth_coach_rules.json — regroupement par défaut,
 * à confirmer : Conservateur/Prudent -> security, Équilibré -> balanced,
 * Croissant/Dynamique -> performance.
 */
export const CATEGORIES = [
  {
    min: 20,
    max: 29,
    label: 'Conservateur',
    description: [
                {id: 1, text: '1- Définition du Profil : Sécurisation de votre patrimoine. La croissance de celui-ci est secondaire. Vous êtes disposé à prendre des risques limités sur votre patrimoine'},
                {id: 2, text: '2- Investissement : obligations 45%, FCP obligataire 45%, placements monétaires ou FCP monétaire 10%'},
                ],
  },
  {
    min: 30,
    max: 32,
    label: 'Prudent (Min)',
    description: [
        {id: 1, text: '1- Définition du Profil : sécurisation de votre patrimoine, avec une faible prise de risques en vue d\'une croissance de vos avoirs sur le long terme'},
        {id: 2, text: '2- Investissement : Obligation 45%, FCP Obligataire 40%, actions 5%, FCP Actions 5%, FCPI ou FCPR, placements monétaires ou FCP Monétaire'},
        ],
  },
  {
    min: 33,
    max: 35,
    label: 'Prudent (Neutre)',
    description: [
        {id: 1, text: '1- Définition du Profil : sécurisation de votre patrimoine, avec une faible prise de risques en vue d\'une croissance de vos avoirs sur le long terme'},
        {id: 2, text: '2- Investissement : Obligation 40%, FCP Obligataire 40%, actions 5%, FCP Actions 5%, placements monétaires ou FCP Monétaire 10%'},
        ],
  },
  {
    min: 36,
    max: 39,
    label: 'Prudent (Max)',
    description: [
        {id: 1, text: '1- Définition du Profil : sécurisation de votre patrimoine, avec une faible prise de risques en vue d\'une croissance de vos avoirs sur le long terme'},
        {id: 2, text: '2- Investissement : Obligation 40%, FCP Obligataire 35%, actions 5%, FCP Actions 10%, placements monétaires ou FCP Monétaire 10%'},
        ],
  },
  {
    min: 40,
    max: 42,
    label: 'Équilibré (Min)',
    description: [
        {id: 1, text: '1- Définition du Profil : croissance de votre patrimoine sur le long terme, avec une prise de risques modérée'},
        {id: 2, text: '2- Investissement : Obligations 30%, FCP obligataire 25%, FCPI/FCPR 10%, Actions 15%, FCP Action 10%, placements monétaires ou FCP monétaire 10%'},
        ],
  },
  {
    min: 43,
    max: 45,
    label: 'Équilibré (Neutre)',
    description: [
        {id: 1, text: '1- Définition du Profil : croissance de votre patrimoine sur le long terme, avec une prise de risques modérée'},
        {id: 2, text: '2- Investissement : Obligations 20%, FCP obligataire 20%, FCPI/FCPR 20%, Actions 20%, FCP Action 10%, placements monétaires ou FCP monétaire 10%'},
        ],
  },
  {
    min: 46,
    max: 49,
    label: 'Équilibré (Max)',
    description: [
        {id: 1, text: '1- Définition du Profil : croissance de votre patrimoine sur le long terme, avec une prise de risques modérée'},
        {id: 2, text: '2- Investissement : Obligations 20%, FCP obligataire 10%, FCPI/FCPR 25%, Actions 20%, FCP Action 15%, placements monétaires ou FCP monétaire 10%'},
        ],
  },
  {
    min: 50,
    max: 52,
    label: 'Croissant (Min)',
    description: [
        {id: 1, text: '1- Définition du Profil : croissance de votre patrimoine sur le long terme, avec une prise de risques élevée. Les revenus de votre patrimoine ont pour vous une importance limitée'},
        {id: 2, text: '2- Investissement : obligations 30%, FCP Obligataire 20%, actions 30%, FCP Actions 10%, FCPI ou FCPR 10%, placements monétaires ou FCP Monétaire 10%'},
        ],
  },
  {
    min: 53,
    max: 56,
    label: 'Croissant (Neutre)',
    description: [
        {id: 1, text: '1- Définition du Profil : croissance de votre patrimoine sur le long terme, avec une prise de risques élevée. Les revenus de votre patrimoine ont pour vous une importance limitée'},
        {id: 2, text: '2- Investissement : obligations 20%, FCP Obligataire 10%, actions 30%, FCP Actions 20%, FCPI ou FCPR 20%, placements monétaires ou FCP Monétaire 10%'},
        ],
  },
  {
    min: 57,
    max: 60,
    label: 'Croissant (Max)',
    description: [
        {id: 1, text: '1- Définition du Profil : croissance de votre patrimoine sur le long terme, avec une prise de risques élevée. Les revenus de votre patrimoine ont pour vous une importance limitée'},
        {id: 2, text: '2- Investissement : obligations 10%, FCP Obligataire 10%, actions 30%, FCP Actions 20%, FCPI ou FCPR 30%, placements monétaires ou FCP Monétaire 10%'},
        ],
  },
  {
    min: 61,
    max: 64,
    label: 'Dynamique (Min)',
    description: [
        {id: 1, text: '1- Définition du Profil : croissance de votre patrimoine sur le long terme avec prise de risques très élevée. Les revenus de votre patrimoine n\'ont pour vous aucune importance'},
        {id: 2, text: '2- Investissement : Obligations 10%, Actions 35%, FCP Actions 25%, FCPI ou FCP 30%'},
        ],
  },
  {
    min: 65,
    max: 68,
    label: 'Dynamique (Neutre)',
    description: [
        {id: 1, text: '1- Définition du Profil : croissance de votre patrimoine sur le long terme avec prise de risques très élevée. Les revenus de votre patrimoine n\'ont pour vous aucune importance'},
        {id: 2, text: '2- Investissement : Obligations 5%, Actions 35%, FCP Actions 30%, FCPI ou FCP 30%'},
        ],
  },
  {
    min: 69,
    max: 72,
    label: 'Dynamique (Max)',
    description: [
        {id: 1, text: '1- Définition du Profil : croissance de votre patrimoine sur le long terme avec prise de risques très élevée. Les revenus de votre patrimoine n\'ont pour vous aucune importance'},
        {id: 2, text: '2- Investissement : Actions 50%, FCP Actions 20%, FCPI ou FCPR 30%'},
        ],
  },
];
